import { omit } from 'lodash'

import {
  EarnData,
  BridgeData,
  MetadataPayloads,
  SwapData,
  TransferData,
  ClaimData,
  CustomCallData,
  PositionClaimData,
} from '~/types'

export const parseTransactionMetadata = (
  transactionMetadata?: MetadataPayloads[],
): {
  transferData?: TransferData
  swapData?: SwapData
  bridgeData?: BridgeData
  earnData?: EarnData
  claimData?: ClaimData
  positionClaimData?: PositionClaimData
  customCallData?: CustomCallData
} => {
  // Somewhere between the prisma types insisting this field
  // is "unknown" and kysely constructing the sql, transactionMetadata
  // will get added to the database as an empty object even if an empty
  // array is passed in. This defends against hard errors if that happens.
  if (
    !transactionMetadata ||
    !Array.isArray(transactionMetadata) ||
    transactionMetadata.length === 0
  ) {
    return {
      transferData: undefined,
      swapData: undefined,
      bridgeData: undefined,
      earnData: undefined,
      claimData: undefined,
      positionClaimData: undefined,
      customCallData: undefined,
    }
  }

  const transferPayload = transactionMetadata.find((m) => m.type === 'transfer')
  const swapPayload = transactionMetadata.find((m) => m.type === 'swap')
  const bridgePayload = transactionMetadata.find((m) => m.type === 'bridge')
  const earnPayload = transactionMetadata.find((m) => m.type === 'earn')
  const claimPayload = transactionMetadata.find((m) => m.type === 'claim')
  const positionClaimPayload = transactionMetadata.find(
    (m) => m.type === 'position_claim',
  )
  const customCallPayload = transactionMetadata.find(
    (m) => m.type === 'custom_call',
  )

  return {
    transferData: transferPayload
      ? (omit(transferPayload, 'type') as TransferData)
      : undefined,
    swapData: swapPayload ? (omit(swapPayload, 'type') as SwapData) : undefined,
    bridgeData: bridgePayload
      ? (omit(bridgePayload, 'type') as BridgeData)
      : undefined,
    earnData: earnPayload ? (omit(earnPayload, 'type') as EarnData) : undefined,
    claimData: claimPayload
      ? (omit(claimPayload, 'type') as ClaimData)
      : undefined,
    positionClaimData: positionClaimPayload
      ? (omit(positionClaimPayload, 'type') as PositionClaimData)
      : undefined,
    customCallData: customCallPayload
      ? (omit(customCallPayload, 'type') as CustomCallData)
      : undefined,
  }
}
